import RetailBanner from './RetailBanner';
import RetailSection from './RetailSection';

function Retail() {
  return (
    <div>
      <RetailBanner />
      <RetailSection />
    </div>
  );
}

export default Retail;